import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import "./HistoryPopup.scss";
import SampleItem from "./SampleItem";
import { resumeGetHistory } from "../../../Store/Actions/ResumeActions";
import { JsonEditorContextProvider } from "../../../Context/jsonEditorContext";

function HistoryPopup(props) {
  const dispatch = useDispatch();
  const resumeHistory = useSelector((state) => state.resumeHistory.data);
  const { id } = useParams();

  const [selectedHistory, setSelectedHistory] = useState("");

  useEffect(() => {
    if (props.showHistory) {
      dispatch(resumeGetHistory(id));
    }
  }, [props.showHistory]);

  useEffect(() => {
    if (resumeHistory && resumeHistory.data && resumeHistory.data.history) {
      let data = JSON.parse(
        resumeHistory && resumeHistory.data && resumeHistory.data.history
      );
      setSelectedHistory(data[0].history[0].data);
    }
  }, [resumeHistory]);

  const handleSelectHistory = (data) => {
    setSelectedHistory(data);
  };

  const handleUseHistory = () => {
    props.updateHistoryData(selectedHistory);
  };

  return (
    <>
      <Modal
        className="history-resume-modal "
        show={props.showHistory}
        aria-labelledby="contained-modal-title-vcenter"
        fullscreen={true}
        onEscapeKeyDown={props.hideShowHistorysModal}
      >
        <Modal.Body className="history-resume-modal-body">
          <img
            onClick={() => props.hideShowHistorysModal()}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close historypopup-close"
          />
          <div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-2 col-lg-2 historypopup-left-wrapper">
                <h4 className="text-center mb-4">Version History</h4>
                <div>
                  {resumeHistory &&
                  resumeHistory.data &&
                  resumeHistory.data.history &&
                  JSON.parse(resumeHistory?.data?.history).length > 0 ? (
                    <>
                      {resumeHistory &&
                        resumeHistory.data &&
                        resumeHistory.data.history &&
                        JSON.parse(resumeHistory?.data?.history).map(
                          (resp, index) => (
                            <>
                              <p>{resp?.date}</p>
                              {resp?.history.map((result) => (
                                <p
                                  className="text-center"
                                  style={{
                                    fontSize: "12px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleSelectHistory(result.data)
                                  }
                                >
                                  {result?.saved_at}
                                </p>
                              ))}
                            </>
                          )
                        )}
                    </>
                  ) : resumeHistory && resumeHistory.data ? (
                    <>
                      <p>No History available!</p>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-10 col-lg-10">
                <div className="history-template-preview">
                  {selectedHistory && selectedHistory != "" && (
                    <>
                      <div className="text-center mb-3">
                        <button
                          className="btn btn-success text-center"
                          onClick={() => handleUseHistory()}
                        >
                          Use this data
                        </button>
                      </div>
                      <JsonEditorContextProvider>
                        <div>
                          <SampleItem
                            resumedata={selectedHistory.content}
                            index={1}
                            randomTemplate={selectedHistory.template_id}
                            full
                          />
                        </div>
                      </JsonEditorContextProvider>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default HistoryPopup;
